import styled from 'styled-components';

export const Layout = styled.div`
  width: 100%;
  min-height: 1080px;
  position: relative;
`;
export const Main = styled.main`
  width: 1280px;
  min-height: calc(100% - 82px - 220px);
  margin: 0 auto 100px;
`;
